import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { MachineAlarm } from '@interfaces/machines';
import moment from 'moment';
import { PanelProps } from '@components/operatorPanel/components/panel';

interface HomePageTopCentralPartProps extends Pick<PanelProps, 'CC' | 'scale' | 'font'> {
  alarms?: MachineAlarm[];
}

const HomePageTopCentralPart: FC<HomePageTopCentralPartProps> = ({ CC, alarms, scale = initialScale, font = initialFont, }) => {
  if (!alarms || !alarms?.length) {
    return null;
  }

  const latestAlarm = [...alarms].sort((a, b) => moment(b.startedOn).valueOf() - moment(a.startedOn).valueOf())[0];

  return (
    <View>
      <View
        style={{
          backgroundColor: CC('Background/Light/Warning'),
          paddingTop: scale(3),
          paddingBottom: scale(4),
          paddingHorizontal: scale(9),
          borderRadius: scale(11),
          alignItems: 'center',
          marginBottom: scale(3),
          alignSelf: 'center',
        }}
      >
        <Text style={[font['Button 2'], { color: CC('Label/Light/AlwaysLight Primary') }]}>{i18n.t('Alarm')}</Text>
      </View>
      <Text style={[font.Body, { color: CC('Label/Light/AlwaysLight Secondary') }]}>{latestAlarm?.errorText}</Text>
    </View>
  );
};

export { HomePageTopCentralPart };
